import "./styles.scss";

export const InputCopy = ({ onCopy, label, className, value, handleInputChange = () => {} }) => {
  return (
    <div className={`input-copy-wrapper ${className ? className : ""}`}>
      {label ? <label>{label}</label> : ""}
      <div className="input-copy-container">
        <input type="text" className="input-field" value={value} onChange={(e) => handleInputChange(e.target.value)} />
        {onCopy ? (
          <div onClick={onCopy} className="copy-button">
            <span
              className="copy-button-icon"
              style={{
                WebkitMaskImage: 'url("/general-assets/copy-svg.svg")',
                maskImage: 'url("/general-assets/copy-svg.svg")',
              }}
              aria-label="Copy"
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
